exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-media-video-wrapper {\n  position: relative;\n  background-color: black; }\n  .video-player-cover .o-media-video-wrapper {\n    height: 100%;\n    width: 100%;\n    padding: 0; }\n\n.o-media-video-stamp-tag {\n  position: absolute;\n  top: 1.2rem;\n  left: 2rem;\n  color: white;\n  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);\n  pointer-events: none; }\n\n.o-media-video-stamp {\n  position: absolute;\n  top: 2rem;\n  left: 2rem;\n  color: white;\n  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);\n  font-size: 1rem;\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/video-player/video-player.component.scss
// module id = ../../../../../src/app/shared/components/video-player/video-player.component.scss
// module chunks = main